//
// Generated class BankMovement
//

/// <reference path="BankMovement_ManagedObject.ts" />

class BankMovement extends BankMovement_ManagedObject
{
}
